export const  HeroAnimation ={
    content:{
        start:{
            y:100,
            opacity:0
        },
        animation:{
            y:0,
            opacity:1
        }
        
    },
    icons:{
        start:{
            opacity:0,
            scale:0
        },
        animation:{
            opacity: 1,
            scale:1
        }
    },
    experience:{
        start:{
            opacity:0
        },
        animation:{
            opacity: 1
        }
    }
}